import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BFPageHeader.css';

export interface BFBreadcrumb {
    label: string;
    path?: string;
}

export interface BFPageHeaderProps {
    title: string;
    breadcrumbs?: BFBreadcrumb[];
    actions?: React.ReactNode;
    className?: string;
}

export function BFPageHeader({ title, breadcrumbs, actions, className = '' }: BFPageHeaderProps) {
    const navigate = useNavigate();

    return (
        <div className={`bf-page-header ${className}`}>
            <h1 className="bf-page-header__title">{title}</h1>
            <div className="bf-page-header__right">
                {breadcrumbs && breadcrumbs.length > 0 && (
                    <nav className="bf-page-header__breadcrumbs" aria-label="breadcrumb">
                        {breadcrumbs.map((crumb, index) => (
                            <span key={crumb.label} className="bf-page-header__breadcrumb-item">
                                {index > 0 && <span className="bf-page-header__breadcrumb-sep">/</span>}
                                {crumb.path ? (
                                    <button
                                        type="button"
                                        className="bf-page-header__breadcrumb-link"
                                        onClick={() => navigate(crumb.path!)}
                                    >
                                        {crumb.label}
                                    </button>
                                ) : (
                                    <span className="bf-page-header__breadcrumb-current">{crumb.label}</span>
                                )}
                            </span>
                        ))}
                    </nav>
                )}
                {actions && <div className="bf-page-header__actions">{actions}</div>}
            </div>
        </div>
    );
}
